// barcode example:
// (240)MLEIPA2931(10)1P40422120(11)020524(91)MM24-1066(37)18(310y)540(23x)000002
// This function is used to extract the barcode data from the barcode string.
// Each data is separated by unique identifier, for example:
// (240) = Product Code
// (10) = Batch Number
// and so on...
// the result should be an object with key-value pair of the data.
// For example:
// { product_code: 'MLEIPA2931', batch_number: '1P40422120', ... }
const extractBarcodeData = (barcode) => {
  const keyMap = {
    240: "kode_barang",
    10: "kode_produksi",
    11: "tanggal_produksi",
    91: "nomor_po",
    37: "konversi",
    "310Y": "berat",
    "23X": "serial",
  };

  const data = {};
  const barcodeArr = barcode.toUpperCase().split("(");
  for (let i = 1; i < barcodeArr.length; i++) {
    const barcodeData = barcodeArr[i].split(")");
    const key = keyMap[barcodeData[0]];
    const value = barcodeData[1].replace(" ", "").trim();
    data[key] = value;
  }

  const dateTxt = data.tanggal_produksi; // date format: YYMMDD
  const dateObject = new Date(
    `20${dateTxt.substring(0, 2)}-${dateTxt.substring(
      2,
      4
    )}-${dateTxt.substring(4, 6)}`
  );
  data.tanggal_produksi = dateObject;

  return data;
};
export default extractBarcodeData;
